import { Element, useEditor, useNode } from "@craftjs/core";
import React, { useEffect, useState } from "react";

import { Action as Button } from "@/src/components/Action";
import { Title } from "../Title";
import { FlexBox } from "../FlexBox";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";
import { isMobile } from "react-device-detect";

export function useDynamicHeight(isOpen?: boolean) {
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const updateHeight = () => setHeight(window.innerHeight);

    if (isOpen) {
      window.addEventListener("resize", updateHeight);
      updateHeight();
    } else {
      window.removeEventListener("resize", updateHeight);
    }

    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, [isOpen]);

  return height;
}

export function Modal({
  children,
  id,
  open = false,
  withoutTrigger = false,
  onSubmitClick,
  onClose,
  withoutCloseOnSubmit = false,
  ...props
}: any) {
  const {
    actions: { setProp },
  } = useEditor();
  const { id: nodeID } = useNode((node) => ({
    id: node.id,
  }));
  const [isOpen, setIsOpen] = useState(open);
  const height = useDynamicHeight(isOpen);

  useEffect(() => {
    // setProp(nodeID, (props) => {
    //   props["open"] = open;
    // });

    setIsOpen(open);
  }, [open, setProp, nodeID]);

  const handleClose = () => {
    setProp(nodeID, (props) => {
      props["open"] = false;
    });
    setIsOpen(false);
    onClose?.();
  };

  return (
    <Dialog
      modal={false}
      open={isOpen}
      onOpenChange={(isOpen) => {
        // setProp(nodeID, (props) => {
        //   props["open"] = isOpen;
        // });
        setIsOpen(isOpen);

        if (!isOpen) {
          onClose?.();
        }
      }}
      {...props}
    >
      {withoutTrigger ? null : (
        <DialogTrigger>
          {children ? (
            children
          ) : (
            <Element is={Button} id={id + "_trigger"}>
              Share
            </Element>
          )}
        </DialogTrigger>
      )}
      <DialogContent
        className={
          "max-md:animate-up-modal max-md:rounded-tl-md max-md:rounded-tr-md max-md:bottom-modal sm:max-w-lg"
        }
        style={
          {
            cssText: `bottom: ${height}px !important;`,
          } as any
        }
        close={handleClose}
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>
            <Element
              id={id + "_title"}
              is={Title}
              text={"Умови страхування"}
              size={"h3"}
              className="flex-1 text-center text-2xl"
              textAlign={"center"}
              background={
                "linear-gradient(90deg, rgb(0,157,222) 0%, rgb(35,70,120) 100%)"
              }
            />
          </DialogTitle>
        </DialogHeader>
        <Element
          is={FlexBox}
          style={{ flexDirection: "column", gap: 24 }}
          canvas
          id={id + "_content"}
        />
        <DialogFooter className="flex flex-row items-center max-md:w-full max-md:gap-2 sm:justify-end">
          <DialogClose className="max-md:w-full max-md:[&&&_button]:w-full">
            <Element is={Button} variant={"outlined"} id={id + "_cansel"}>
              Скасувати
            </Element>
          </DialogClose>
          <div
            onClick={() => {
              onSubmitClick();
              !withoutCloseOnSubmit && handleClose();
            }}
            className="max-md:w-full max-md:[&&&_button]:w-full"
          >
            <Element is={Button} id={id + "_save"}>
              Зберегти
            </Element>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
